import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/layout.css';
import App from './App';
import $ from 'jquery';
import Popper from 'popper.js';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import reportWebVitals from './reportWebVitals';
import LandingPage from './Components/LandingPage/LandingPage';
import {BrowserRouter as Router, Link, Routes, Route} from 'react-router-dom';
import history from './Components/util/History';
import {useForm} from "react-hook-form";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router history={history}>
        <App/>
    </Router>
);

reportWebVitals();